import https from "../../configs/axios.config";
import { API_ROUTES } from "../../constants/API_ROUTES";

export const ticketService = {
  get_all: async (search, fromDate, toDate, page, limit, token) => {
    const params = new URLSearchParams({
      search_value: search || "",
      from_date: fromDate || "",
      to_date: toDate || "",
      page: page || "1",
      limit: limit || "10",
    }).toString();

    const response = await https.get(`/user/ticket?${params}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  },
  get_ticket_by_id: async (ticket_id, token) => {
    const response = await https.get(`/user/ticket/${ticket_id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  },
  create_ticket_by_profileid: (profile_id, message, token) => {
    const uri = `${API_ROUTES.TICKET.CREATE}/${profile_id}`;
    return https.post(
      uri,
      {
        message: message,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
  },
  create_ticket: (category, name, phone, email, message, token) => {
    const uri = API_ROUTES.TICKET.CREATE;
    return https.post(
      uri,
      {
        category: category,
        name: name,
        phoneNumber: phone,
        email: email,
        message: message,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
  },
};
